"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _BioentityProperty = _interopRequireDefault(require("./BioentityProperty"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BioentityInformation = function BioentityInformation(_ref) {
  var className = _ref.className,
      bioentityProperties = _ref.bioentityProperties;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement("table", {
    className: "hover"
  }, /*#__PURE__*/_react["default"].createElement("tbody", null, bioentityProperties.map(function (property, index) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      key: index
    }, /*#__PURE__*/_react["default"].createElement("th", {
      style: {
        whiteSpace: "nowrap"
      }
    }, property.name), /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement(_BioentityProperty["default"], property)));
  }))));
};

BioentityInformation.propTypes = {
  className: _propTypes["default"].string,
  bioentityProperties: _propTypes["default"].array
};
BioentityInformation.defaultProps = {
  className: "row column expanded"
};
var _default = BioentityInformation;
exports["default"] = _default;